import { withRouter } from 'src/hoc/withRouter';
import ErrorPageWithCustomMessage from './ErrorPageWithCustomMessage';

const ErrorPageStandalone = ErrorPageWithCustomMessage;
const ErrorPageWithRouter = withRouter(ErrorPageWithCustomMessage);

export { ErrorPageStandalone, ErrorPageWithRouter };
